module.exports = {
	"classes": [
		"mcc-page",
		"header-dark"
	],
	"title": "Model Contract Clause",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/mcc/metadata.json
// module id = 1133
// module chunks = 0